import { REGIONS, STATES } from "@/lib/location-directory";

// Links from a state hub to every other state hub and regional page. Before
// this block, /locations/ was the only page that linked to each state hub and
// to most regional pages (Ahrefs, 3 Oct 2026).
export function OtherLocations({ currentPath }: { currentPath: string }) {
  const states = STATES.filter((s) => `/locations/${s.slug}/` !== currentPath);
  const regions = REGIONS.filter((r) => r.href !== currentPath);
  return (
    <section className="bg-background py-12">
      <div className="mx-auto max-w-5xl px-4 text-center lg:px-8">
        <h2 className="text-xl font-extrabold text-foreground md:text-2xl">Other RESTORE Locations</h2>
        <nav aria-label="Other states" className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm">
          {states.map((s) => (
            <a key={s.slug} href={`/locations/${s.slug}/`} className="text-primary underline underline-offset-4 hover:no-underline">
              {s.name}
            </a>
          ))}
        </nav>
        <nav aria-label="Regions" className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm font-semibold">
          {regions.map((r) => (
            <a key={r.href} href={r.href} className="text-foreground underline underline-offset-4 hover:text-primary">
              RESTORE {r.label}
            </a>
          ))}
        </nav>
      </div>
    </section>
  );
}
